module.exports = __webpack_public_path__ + "static/media/(000048).eca027cb.jpg";